import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import TextField from './../../component/TextField';
import ModalMessage from './../../component/ModalMessage';
import ErrorPopUp from './../../component/errorPopUp';
import PopUpCustomAll from './../../component/fpg/create/popUpCustomAll';

import Projectinfo from './../../component/paf/Projectinfo'
import ProjectContact from './../../component/paf/ProjectContact'
import ProjectInternal from './../../component/paf/ProjectInternal'
import service from './../../services'
//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from './../../redux/bindActionCretor'
import moment from 'moment';
import RecordPresenceBanner from './../../component/RecordPresenceBanner';
import ConflictSaveModal from './../../component/ConflictSaveModal';

let sub;
const mapStateToProps = state => ({
    titleProjectInfoget: state.titleProjectInfoget,
    PostAcceptanceEditListId: state.PostAcceptanceEditListId,
    recordViewers: state.recordViewers,
    recordConflict: state.recordConflict,
    getLoginAdminByID: state.getLoginAdminByID,
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};
class PafProjectCreate extends Component {

    constructor(props) {
        super(props)
        this.apiserve = new service();
        this._hasLeftPresence = false;
        this._hasJoinedPresence = false;
        this.state = {
            flag:false,
            showConflictModal: false,
            submissionSlide:false,
            title:'',
            submitBy:[],
            submitNo: 0,
            projectTab:[
                {
                    label:"FPG & Project Info",
                    id:"FpgProject"
                },
                {
                    label:"Contacts",
                    id:"Contacts"
                },
                {
                    label:"Internal Info",
                    id:"InternalInfo",
                }
            ],
            default:"FpgProject"
        }
    }

    componentWillUnmount = () => {
        window.removeEventListener('beforeunload', this._handleBeforeUnload);

        const recordId = this.state.projectId;
        if (recordId && !this._hasLeftPresence) {
            this.apiserve.sendevent("RecordPresence|leave", {
                modelName: "pafProject",
                recordId: recordId
            });
        }

        sub.unsubscribe();
        this.props.ClearRecordPresence();
    }

    _handleBeforeUnload = () => {
        if (this._hasLeftPresence) return;
        this._hasLeftPresence = true;

        const recordId = this.state.projectId;
        if (recordId) {
            this.apiserve.sendevent("RecordPresence|leave", {
                modelName: "pafProject",
                recordId: recordId
            });
        }
    }

    ScreenToggle = (e) => {
        var active = e.target.parentNode.closest(".submission_slide").classList.toggle("active");
        var panel = e.target.parentNode.closest(".submission_slide").querySelector(".submission_slide_inner");
          if (panel && panel.style.maxHeight) {
            panel.style.maxHeight = "";
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        this.setState({
          submissionSlide:!this.state.submissionSlide
        })
    }

    handleClick = (e,id) => {
        this.setState({
            default:id
        })

    }

    componentDidMount = () => {
        this.props.ClearRecordPresence();
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "paf|project|getProjectInfo":
                    if(!response.error){
                        this.setState({
                            ...this.state,
                            title: response.data.title,
                            submitBy:response.data.submitBy,
                            projectId:response.data._id,
                            submitNo: response?.data?.submitNo ?? 0
                        });
                        const recordId = response.data._id;
                        if (recordId && !this._hasJoinedPresence) {
                            this._hasJoinedPresence = true;
                            this.apiserve.sendevent("RecordPresence|join", {
                                modelName: "pafProject",
                                recordId: recordId
                            });
                            window.addEventListener('beforeunload', this._handleBeforeUnload);
                        }
                    }
                break;
                case 'paf|project|downloadStep':
                    if (!response.error) {
                        window.open(response.data.location, "_self");
                    }
                    break;

                case "RecordPresence|viewersUpdate":
                    if (response?.data?.recordId === this.state.projectId) {
                        const currentUserId = this.props.getLoginAdminByID;
                        const viewers = response?.data?.viewers || [];
                        const currentUserSessionCount = viewers.filter(v => v?.userId === currentUserId).length;
                        const currentUserHasMultipleSessions = currentUserSessionCount > 1;
                        const seenIds = new Set();
                        const filteredViewers = viewers
                            .filter(v => {
                                if (v?.userId === currentUserId) {
                                    return currentUserHasMultipleSessions;
                                }
                                return true;
                            })
                            .filter(v => {
                                if (seenIds.has(v?.userId)) return false;
                                seenIds.add(v?.userId);
                                return true;
                            })
                            .map(v => ({
                                userId: v?.userId,
                                userName: `${v?.fname || ''} ${v?.lname || ''}`.trim() || 'Unknown User'
                            }));
                        this.props.SetRecordViewers(filteredViewers);
                    }
                    break;

                case "RecordPresence|recordUpdated":
                    if (response?.data?.recordId === this.state.projectId && response?.data?.updatedBy?._id !== this.props.getLoginAdminByID) {
                        const updatedBy = response?.data?.updatedBy;
                        this.props.SetRecordConflict({
                            userName: updatedBy
                                ? `${updatedBy?.fname || ''} ${updatedBy?.lname || ''}`.trim()
                                : 'another user',
                            updatedAt: response?.data?.updatedAt
                        });
                    }
                    break;

                default:
                break;
            }
        });
    }
    DOWNLOADSTEP = (e, step)=>{

        let data={
            projectId:this.state.projectId,
            stepNo:step,
        }

        this.apiserve.sendevent("paf|project|downloadStep", data);

    }

    render() {

    return (
            <>

            <div className="right_side_wrapper">
                <div className="fpg_admin_tab">
                    <ul className="fpg_admin_tab disp_flex">
                        <li className="active">
                            <p className="uppercase text_center">
                                <div>Post Acceptance Form: {this.state.title}</div>
                            </p>
                        </li>
                    </ul>
                </div>
                <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                            <Link className="back_link" to='/paf-projectlist'> <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black"/> </svg> Back To List</Link>
                            {/* {this.state.getLastUpdated && this.state.getLastUpdated.updatedAt === undefined ? '' :
                              <p className="update_date">Last Update: {hour}:{minutes} {state} - {moment(updateAt).format('MM/DD/YYYY')} Last Updated By: {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname} </p>
                            } */}
                        </div>
                <RecordPresenceBanner
                    activeViewers={this.props.recordViewers}
                    conflict={this.props.recordConflict}
                />
                <div className="fpg_tabcontent paf_view_page pl_15 fpg_create_film">
                    <div className="d_flex d_flex_align_center d_flex_justify_spacebt">
                        <ul className="project_header_tab disp_flex">
                            {
                                this.state.projectTab.map((item) => {
                                    return(

                                        <li className={`d_flex d_flex_align_center d_flex_justify_center pointer ${this.state.default === item.id ? 'active' : ''}`}>
                                            <p className="text_center">
                                                <div onClick={(e)=>this.handleClick(e,item.id)} name={item.label}>{item?.label}</div>
                                            </p>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                        <div className={`submission_slide ${this.state.submissionSlide ? 'active': ''}`}>
                            <div className="submission_slide_title pointer" onClick={(e) => this.ScreenToggle(e)}>
                                <p className="uppercase">Submission Information</p>
                            </div>
                            <div className="submission_slide_inner">
                                <div className="screen_dates">
                                    <div className="header_title">
                                        <h3>Submission Date / Time (MT) - Page Submitted - Submitter Name - Submitter Email - Relation to Film/Project</h3>
                                    </div>
                                    <div className="screen_list">

                                        <ul>
                                            {/* <li className="disp_flex">
                                                <span className="screen_list_date">Sept. 3 11:43 PM</span>
                                                <span className="screen_list_step">Step 1</span>
                                                <span className="screen_list_name">Anna Elizabeth Ross</span>
                                            </li>
                                            <li className="disp_flex">
                                                <span className="screen_list_date">Sept. 3 11:43 PM</span>
                                                <span className="screen_list_step">Step 1</span>
                                                <span className="screen_list_name">Anna Elizabeth Ross</span>
                                            </li> */}
                                                {this.state.submitBy.map((item)=>{
                                                    return(
                                                        <li className="disp_flex">
                                                            <span className="screen_list_date">{moment(item.date).tz("America/Denver").format('MMM. DD h:mm A')}</span>
                                                            <span className={`screen_list_step pointer ${this.state.submitNo === 2 && "step_com"}`} onClick={(e) => this.DOWNLOADSTEP(e,item.step)} style={{ textDecoration:"underline"}}>Page {item.step} {item.step === 2 ? " - 9" : ""}</span>
                                                            <span className="screen_list_name">{item.name}</span>
                                                            <span className="" style={{marginRight:'15px'}}>{item.email}</span>
                                                            <span className="">{item.relationToFilm}</span>
                                                        </li>
                                                    )
                                                })}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                            {
                                this.state.default === 'FpgProject'? <Projectinfo history={this.props.history} /> :  this.state.default === 'Contacts'?   <ProjectContact   history={this.props.history}/>:  this.state.default === 'InternalInfo'?    <ProjectInternal  default={this.state.default} history={this.props.history}/> :""
                            }




                    {this.state.messageModal &&
                        <ModalMessage messageModal={this.state.messageModal} withoutEmail="Few or all of the required fields are missing. Please scroll up and check to add and confirm and resubmit" ClosemessageModal={this.ClosemessageModal} />
                    }

                    {this.state.errorPopup ?
                            <ErrorPopUp
                            errorMsg={this.state.errorMsg}
                            errorMsgPopup={this.errorMsgPopup}
                            />
                        : ''
                    }
                    {this.state.deleteImagePopup ? (
                        <PopUpCustomAll
                        HeaderName="Delete Image?"
                        insideDetails="Are You Sure ?"
                        insideData="You want to delete this image"
                        popupState={this.closeAdminUser}
                        yesPopUp={this.deleteImagePopup}
                    />
                    ) : (
                        ""
                    )}
                    {this.state.discardPopup ? (
                        <PopUpCustomAll
                        HeaderName="Discard Changes?"
                        insideDetails="Leaving this page without saving will discard all changes"
                        insideData="Do you want to proceed?"
                        popupState={this.closeAdminUser}
                        yesPopUp={this.discardPopupYes}
                    />
                    ) : (
                        ""
                    )}
                </div>
            </div>

        <ConflictSaveModal
            isVisible={this.state.showConflictModal}
            conflict={this.props.recordConflict}
            onClose={() => this.setState({ showConflictModal: false })}
        />
          </>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PafProjectCreate)
